import type { MemberFilter, MemberFilterOption } from '../../hooks/milemarker/useMilemarkerData'
import Tabs from '../primitives/Tabs'

interface TeamFilterPillsProps {
  value: MemberFilter
  options: MemberFilterOption[]
  onChange: (value: MemberFilter) => void
}

export default function TeamFilterPills({ value, options, onChange }: TeamFilterPillsProps) {
  return (
    <Tabs
      value={String(value)}
      onChange={(next) => {
        const match = options.find((item) => String(item.value) === next)
        if (match) onChange(match.value)
      }}
      items={options.map((item) => ({
        value: String(item.value),
        label: item.label,
      }))}
      variant="pill"
    />
  )
}
